export { default } from './SubmitConfirmation'
export * from './SubmitConfirmation'
